import { useContext, useState, useEffect  } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";
import MyNavbar from "../../../components/Customer/Mynavbar/MyNavbar";
import Footer from "../../../components/Customer/Footer/Footer";
import Swal from "sweetalert2";
import axios from "axios";
import "../../../assests/css/customer/CheckoutPage/CheckoutPage.css";
import AppContext from "../../../context/AppContext";

const cities = [
  "Karachi",
  "Lahore",
  "Islamabad",
  "Rawalpindi",
  "Faisalabad",
  "Multan",
  "Gujranwala",
  "Sialkot",
  "Peshawar",
  "Quetta",
];

const formatPKR = (amount) =>
  `Rs. ${Number(amount).toLocaleString("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export default function CheckoutPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    cartItems = [],
    subtotal: cartSubtotal = 0,
    discount: cartDiscount = 0,
    shipping: cartShipping = 0,
    total: cartTotal = 0,
    appliedCoupon = null,
  } = location.state || {};

  const [contact, setContact] = useState("");
  const [newsletter, setNewsletter] = useState(true);
  const [city, setCity] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [apartment, setApartment] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [phone, setPhone] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [payment, setPayment] = useState("cod");
  const [discountCode, setDiscountCode] = useState("");
  const [extraDiscount, setExtraDiscount] = useState(0);
  const [showTruck, setShowTruck] = useState(false);
    const { baseUrl, customer, setCartCount, setCartItems } = useContext(AppContext);

  const total = cartTotal - extraDiscount;

  // Agar customer login nahi hai, use login page pe redirect kar do
  useEffect(() => {
    if (!customer) {
      Swal.fire({
        icon: "error",
        title: "Login Required",
        text: "Please login first",
      }).then(() => navigate("/login"));
    }
  }, [customer, navigate]);

  const clearCart = () => {
    setCartItems([]);
    setCartCount(0);
  };

  const handlePay = async (e) => {
    e.preventDefault();

    const orderData = {
      mlcustomer_id: customer?.id,
      contact,
      firstName,
      lastName,
      address,
      apartment,
      city,
      postalCode,
      phone,
      payment_method: payment,
      cartItems,
      subtotal: cartSubtotal,
      discount: cartDiscount + extraDiscount,
      shipping: cartShipping,
      total,
      appliedCoupon: appliedCoupon?.code || null,
    };

    if (payment === "cod") {
      setShowTruck(true);
      try {
        const response = await axios.post(
          `${baseUrl}/customer/order/createorder`,
          orderData,
        );
        console.log(response.data);
        setTimeout(() => {
          setShowTruck(false);
          clearCart();
          Swal.fire({
            icon: "success",
            title: "Order Placed! 🎉",
            html: `
              <p style="font-family:'Jost',sans-serif; color:#555; line-height:1.6;">
                Shukriya! Aapka order successfully place ho gaya hai.<br/>
                Hum jald hi aap tak deliver karenge.
              </p>
            `,
            confirmButtonText: "Continue Shopping",
            confirmButtonColor: "#AD8B73",
            customClass: {
              popup: "swal-custom-popup",
              title: "swal-custom-title",
              confirmButton: "swal-custom-btn",
            },
          }).then(() => {
            navigate("/");
          });
        }, 1500);
      } catch (err) {
        console.log("FULL ERROR:", err);
        setShowTruck(false);
        Swal.fire({
          icon: "error",
          title: "Backend Error",
          text:
            err.response?.data?.error ||
            err.response?.data?.message ||
            "Unknown Error",
          confirmButtonColor: "#AD8B73",
        });
      }
    } else if (payment === "stripe") {
      setShowTruck(true);
      try {
        const response = await axios.post(
          `${baseUrl}/customer/order/createorder`,
          orderData,
        );
        console.log(response.data);

        if (response.data.url) {
          clearCart();
          window.location.href = response.data.url;
        }
      } catch (err) {
        console.log("STRIPE ERROR:", err);
        setShowTruck(false);
        Swal.fire({
          icon: "error",
          title: "Payment Error",
          text:
            err.response?.data?.error ||
            err.response?.data?.message ||
            "Unknown Error",
          confirmButtonColor: "#AD8B73",
        });
      }
    }
  };

  const applyDiscount = () => {
    if (discountCode.trim().toUpperCase() === "SAVE10") {
      setExtraDiscount(Math.round(cartSubtotal * 0.1 * 100) / 100);
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Code",
        text: "Invalid discount code. Try SAVE10",
        confirmButtonColor: "#AD8B73",
      });
    }
  };

  return (
    <>
      <MyNavbar />
      <br />
      <br />
      <br />
      <br />

      <div className="checkout-page-wrapper">
        {/* ── Page Header ── */}
        <div className="checkout-page-header">
          <div className="checkout-title-section">
            <ShoppingBag size={28} className="checkout-icon-header" />
            <h1 className="checkout-page-title">Checkout</h1>
            <span className="checkout-item-count">
              {cartItems.reduce((s, i) => s + i.quantity, 0)} items
            </span>
          </div>
          <button className="back-to-cart-link" onClick={() => navigate(-1)}>
            <ArrowLeft size={18} />
            <span>Back to Cart</span>
          </button>
        </div>

        {/* ── Breadcrumb ── */}
        <nav className="checkout-breadcrumb">
          <span className="bc-link" onClick={() => navigate("/cart")}>
            Cart
          </span>
          <span className="bc-sep">›</span>
          <span className="bc-active">Information</span>
          <span className="bc-sep">›</span>
          <span className="bc-dim">Shipping</span>
          <span className="bc-sep">›</span>
          <span className="bc-dim">Payment</span>
        </nav>

        {/* ── Two-column body ── */}
        <div className="checkout-body">
          {/* ════════ LEFT — Form ════════ */}
          <div className="checkout-left">
            <form onSubmit={handlePay} noValidate>

              {/* Contact */}
              <section className="form-section">
                               <div className="section-header">
                  <h2 className="section-title">Contact</h2>
                </div>
                <div className="field-group">
                  <input
                    className="field-input"
                    type="text"
                    placeholder="Email or mobile phone number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                  />
                </div>
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={newsletter}
                    onChange={(e) => setNewsletter(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  <span>Email me with news and offers</span>
                </label>
              </section>

              {/* Delivery */}
              <section className="form-section">
                <h2 className="section-title">Delivery</h2>

                <div className="field-group">
                  <select
                    className="field-input field-select"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  >
                    <option value="">Select city from dropdown</option>
                    {cities.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>

                <div className="field-group">
                  <select className="field-input field-select" defaultValue="Pakistan">
                    <option value="Pakistan">Pakistan</option>
                  </select>
                </div>

                <div className="field-row">
                  <div className="field-col">
                    <div className="field-group">
                      <input
                        className="field-input"
                        type="text"
                        placeholder="First name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="field-col">
                    <div className="field-group">
                      <input
                        className="field-input"
                        type="text"
                        placeholder="Last name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="field-group">
                  <input
                    className="field-input"
                    type="text"
                    placeholder="Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>

                <div className="field-group">
                  <input
                    className="field-input"
                    type="text"
                    placeholder="Apartment, suite, etc. (optional)"
                    value={apartment}
                    onChange={(e) => setApartment(e.target.value)}
                  />
                </div>

                <div className="field-row">
                  <div className="field-col">
                    <div className="field-group">
                      <input
                        className="field-input"
                        type="text"
                        placeholder="City"
                        value={city}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="field-col">
                    <div className="field-group">
                      <input
                        className="field-input"
                        type="text"
                        placeholder="Postal code (optional)"
                        value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="field-group">
                  <input
                    className="field-input"
                    type="tel"
                    placeholder="Phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                <label className="checkbox-label mt-sm">
                  <input
                    type="checkbox"
                    checked={saveInfo}
                    onChange={(e) => setSaveInfo(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  <span>Save this information for next time</span>
                </label>
              </section>


              {/* Payment */}
              <section className="form-section">
                <h2 className="section-title">Payment</h2>
                <p className="section-subtitle">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" />
                    <path d="M7 11V7a5 5 0 0110 0v4" />
                  </svg>
                  All transactions are secure and encrypted.
                </p>

                {/* stripe option */}
                <div
                  className={`payment-option ${payment === "stripe" ? "selected-option" : ""}`}
                  onClick={() => setPayment("stripe")}
                >
                  <div className="option-left">
                    <span className={`radio-dot ${payment === "stripe" ? "active-dot" : ""}`}></span>
                    <span className="option-label">
                      STRIPE{" "}
                      <span className="option-sub">(Debit / Credit / Wallet / Bank Account)</span>
                    </span>
                  </div>
                  <div className="payment-icons">
                    <span className="pay-badge visa-badge">VISA</span>
                    <span className="pay-badge mc-badge">MC</span>
                  </div>
                </div>

                {payment === "stripe" && (
                  <div className="payment-info">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 16v-4M12 8h.01" />
                    </svg>
                    You'll be redirected to Stripe to complete your purchase.
                  </div>
                )}

                {/* COD option */}
                <div
                  className={`payment-option ${payment === "cod" ? "selected-option" : ""}`}
                  onClick={() => setPayment("cod")}
                >
                  <div className="option-left">
                    <span className={`radio-dot ${payment === "cod" ? "active-dot" : ""}`}></span>
                    <span className="option-label">
                      Cash on Delivery <span className="option-sub">(COD)</span>
                    </span>
                  </div>
                </div>
              </section>

              <button
                type="submit"
                className={`pay-btn ${showTruck ? "pay-btn--loading" : ""}`}
                disabled={showTruck}
              >
                {showTruck ? (
                  <span className="truck-wrapper">
                    <svg
                      className="truck-svg"
                      width="52"
                      height="30"
                      viewBox="0 0 80 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="2"
                        y="6"
                        width="44"
                        height="22"
                        rx="4"
                        fill="white"
                        fillOpacity="0.92"
                      />
                      <path
                        d="M46 10 L46 28 L72 28 L72 20 L62 10 Z"
                        fill="white"
                        fillOpacity="0.85"
                      />
                      <path
                        d="M48 12 L48 19 L60 19 L60 12 Z"
                        fill="#AD8B73"
                        fillOpacity="0.55"
                      />
                      <line
                        x1="10"
                        y1="12"
                        x2="10"
                        y2="22"
                        stroke="#AD8B73"
                        strokeWidth="1.2"
                        strokeOpacity="0.4"
                      />
                      <line
                        x1="20"
                        y1="12"
                        x2="20"
                        y2="22"
                        stroke="#AD8B73"
                        strokeWidth="1.2"
                        strokeOpacity="0.4"
                      />
                      <line
                        x1="30"
                        y1="12"
                        x2="30"
                        y2="22"
                        stroke="#AD8B73"
                        strokeWidth="1.2"
                        strokeOpacity="0.4"
                      />
                      <circle
                        cx="16"
                        cy="30"
                        r="6"
                        fill="#AD8B73"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <circle cx="16" cy="30" r="2.5" fill="white" />
                      <circle
                        cx="58"
                        cy="30"
                        r="6"
                        fill="#AD8B73"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <circle cx="58" cy="30" r="2.5" fill="white" />
                      <line
                        x1="0"
                        y1="14"
                        x2="8"
                        y2="14"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeOpacity="0.6"
                        strokeLinecap="round"
                      />
                      <line
                        x1="0"
                        y1="18"
                        x2="12"
                        y2="18"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeOpacity="0.4"
                        strokeLinecap="round"
                      />
                      <line
                        x1="0"
                        y1="22"
                        x2="6"
                        y2="22"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeOpacity="0.5"
                        strokeLinecap="round"
                      />
                    </svg>
                    <span className="road-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </span>
                ) : payment === "cod" ? (
                  <>
                    <span>Complete Order</span>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                  </>
                ) : (
                  <>
                    <span>Pay Now — {formatPKR(total)}</span>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </>
                )}
              </button>
            </form>

            <footer className="checkout-footer">
              <a href="#">Refund policy</a>
              <a href="#">Privacy policy</a>
              <a href="#">Terms of service</a>
            </footer>
          </div>

          {/* ════════ RIGHT — Order Summary ════════ */}
          <div className="checkout-right">
            <div className="order-summary-inner">
              <h3 className="summary-title">Order Summary</h3>

              <div className="order-items">
                {cartItems.length > 0 ? (
                  cartItems.map((item) => (
                    <div key={item.id} className="order-item">
                      <div className="item-img-wrap">
                        <img
                          src={item.image_path}
                          alt={item.name}
                          className="item-img"
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/100x120?text=No+Image";
                          }}
                        />
                        <span className="item-qty-badge">{item.quantity}</span>
                      </div>
                      <div className="item-details">
                        <p className="item-name">{item.name}</p>
                        <p className="item-meta">
                          {item.size && `Size: ${item.size}`}
                          {item.size && item.color && " · "}
                          {item.color && `Color: ${item.color}`}
                        </p>
                      </div>
                      <p className="item-price">
                        {formatPKR(item.price * item.quantity)}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="no-items-msg">
                    No items found.{" "}
                    <span
                      onClick={() => navigate("/cart")}
                      className="section-link"
                    >
                      Go back to cart
                    </span>
                  </p>
                )}
              </div>

              {/* Discount code */}
              <div className="discount-row">
                <div className="field-group discount-field">
                  <input
                    className="field-input"
                    type="text"
                    placeholder="Discount code"
                    value={discountCode}
                    onChange={(e) => setDiscountCode(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  className="apply-btn"
                  onClick={applyDiscount}
                >
                  Apply
                </button>
              </div>

              {extraDiscount > 0 && (
                <p className="discount-success">
                  ✓ Code applied — {formatPKR(extraDiscount)} off
                </p>
              )}

              <div className="summary-lines">
                <div className="summary-line">
                  <span>Subtotal</span>
                  <span>{formatPKR(cartSubtotal)}</span>
                </div>

                {cartDiscount > 0 && (
                  <div className="summary-line discount-line">
                    <span>Coupon ({appliedCoupon?.code})</span>
                    <span>− {formatPKR(cartDiscount)}</span>
                  </div>
                )}

                {extraDiscount > 0 && (
                  <div className="summary-line discount-line">
                    <span>Promo (SAVE10)</span>
                    <span>− {formatPKR(extraDiscount)}</span>
                  </div>
                )}

                <div className="summary-line">
                  <span>Shipping</span>
                  <span className={cartShipping === 0 ? "free-text" : ""}>
                    {cartShipping === 0 ? "FREE" : formatPKR(cartShipping)}
                  </span>
                </div>
              </div>

              <div className="summary-total">
                <span>Total</span>
                <span className="total-amount">{formatPKR(total)}</span>
              </div>

              {/* Trust Badges */}
              <div className="trust-badges">
                <div className="trust-item">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                  <span>Secure Checkout</span>
                </div>
                <div className="trust-item">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span>Free Returns</span>
                </div>
                <div className="trust-item">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span>Fast Delivery</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
